import { SidePanel } from '@wix/design-system';
import classNames from 'classnames';
import React__default from 'react';
import { UiComponentsProvider } from '../../ui-components-provider.js';
import { ROOT } from './data-hooks.js';
import { s as styleInject } from '../../style-inject.es-746bb8ed.js';

var css_248z = "._1bFWq{--wds-side-panel-footer-padding-vertical:18px}";
var classes = {"footer":"_1bFWq"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const FloatingDesktopLayout = ({
  onCloseButtonClick,
  dataHook,
  header,
  content,
  footer
}) => {
  return /* @__PURE__ */ React__default.createElement(UiComponentsProvider, null, /* @__PURE__ */ React__default.createElement(
    SidePanel,
    {
      skin: "floating",
      width: "360px",
      height: "fit-content",
      maxHeight: "420px",
      onCloseButtonClick,
      dataHook: classNames(ROOT, dataHook)
    },
    header && /* @__PURE__ */ React__default.createElement(SidePanel.Header, __spreadValues({}, header)),
    /* @__PURE__ */ React__default.createElement(SidePanel.Content, __spreadValues({ noPadding: true }, content)),
    footer && /* @__PURE__ */ React__default.createElement(SidePanel.Footer, __spreadValues({ className: classes.footer }, footer))
  ));
};

export { FloatingDesktopLayout };
//# sourceMappingURL=floating-desktop-layout.js.map
